import React from "react";
import BaseComponent from "../../BaseComponent.js";
import styled from "styled-components";
import nota from "../../Global/nota.guidelines.json";
import NanoFlex from "../../Global/NanoFlex.js";
import Type from "../../Global/Typography.js";

import Input from "../../Nano/Input.js";

//IMAGES

import logoGlance from "../../../images/glance2.svg";
import logoMediametrie from "../../../images/mediametrieLogo.svg";

const multiple = nota.global.multiple;

const StyledAboutUs = styled(NanoFlex)`
  height: 100%;
  padding: ${multiple * 2 + "px"};
  .headerWrapper {
    height: auto;
    margin-bottom: ${multiple * 3 + "px"};
    h2 {
      text-transform: uppercase;
      em {
        text-transform: none;
        font-weight: bold;
        color: ${nota.color.main.default};
      }
    }
    p {
      margin-left: ${multiple * 2 + "px"};
      margin-bottom: 2px;
    }
  }

  .infoContainer {
    .blockInfoWrapper {
      padding: ${multiple * 2 + "px"};
      margin-bottom: ${multiple * 2 + "px"};
      border: 1px solid ${nota.color.neutral.NeuFour};
      .imgWrapper {
        width: 246px;
        padding: ${multiple * 3 + "px"};
        img {
          max-height: 120px;
          max-width: 168px;
          width: 100%;
          height: 100%;
        }
      }
      .infoWrapper {
        .title {
          margin-bottom: ${multiple + "px"};
          text-transform: uppercase;
        }
        p {
          line-height: 18px;
          text-align: justify;
          margin-bottom: ${multiple + "px"};
          &:last-child {
            margin-bottom: 0;
          }
        }
        a {
          text-decoration: none;
          p {
            em {
              text-transform: unset;
              font-weight: normal;
              cursor: pointer;
              color: ${nota.color.main.default};
              &:hover {
                font-weight: bold;
                line-height: 16px;
              }
            }
          }
        }
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
    .secondaryBlock {
      border: none;
      background-color: ${nota.color.neutral.lightGrey};
    }
  }
  /* MEDIA QUERIES */
  @media only screen and (max-width: 800px) {
    .blockInfoWrapper {
      flex-direction: column;
    }
  }
`;

export class AboutUs extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  render() {
    return (
      <StyledAboutUs>
        <NanoFlex className="viewWrapper" flexDirection={"column"} justifyContent={"flex-start"}>
          <NanoFlex className="headerWrapper" justifyContent={"flex-start"} alignContent={"flex-start"} alignItems={"flex-end"}>
            <Type.h2>
              <em>{this.translation.aboutUs.title}</em>
            </Type.h2>
          </NanoFlex>
          <NanoFlex className="infoContainer" flexDirection={"column"}>
            <NanoFlex className="blockInfoWrapper">
              <NanoFlex className="imgWrapper">
                <a href="https://www.glance-mediametrie.com" rel="noopener noreferrer" target="_blank">
                  <img src={logoGlance} alt="glance" />
                </a>
              </NanoFlex>
              <NanoFlex className="infoWrapper" flexDirection={"column"} justifyContent={"flex-start"} alignItems={"flex-start"}>
                <Type.p className="title">
                  <b>{this.translation.aboutUs.glance.title}</b>
                </Type.p>
                {this.translation.aboutUs.glance.paragraphs.map((p) => {
                  return <Type.p key={p}>{p}</Type.p>;
                })}

                <a href="https://www.glance-mediametrie.com" rel="noopener noreferrer" target="_blank">
                  <Type.p>
                    <em>www.glance-mediametrie.com</em>
                  </Type.p>
                </a>
              </NanoFlex>
            </NanoFlex>

            <NanoFlex className="blockInfoWrapper">
              <NanoFlex className="imgWrapper">
                <a href=" https://mediametrie.fr" rel="noopener noreferrer" target="_blank">
                  <img src={logoMediametrie} alt="glance" />
                </a>
              </NanoFlex>
              <NanoFlex className="infoWrapper" flexDirection={"column"} justifyContent={"flex-start"} alignItems={"flex-start"}>
                <Type.p className="title">
                  <b>{this.translation.aboutUs.mediametrie.title}</b>
                </Type.p>
                {this.translation.aboutUs.mediametrie.paragraphs.map((p) => {
                  return <Type.p key={p}>{p}</Type.p>;
                })}

                <a href=" https://mediametrie.fr" rel="noopener noreferrer" target="_blank">
                  <Type.p>
                    <em>mediametrie.fr</em>
                  </Type.p>
                </a>
              </NanoFlex>
            </NanoFlex>

            <NanoFlex className="blockInfoWrapper secondaryBlock">
              <NanoFlex className="infoWrapper" flexDirection={"column"} justifyContent={"flex-end"} alignItems={"flex-end"}>
                <Type.p className="title">
                  <b>{this.translation.aboutUs.contactUs}</b>
                </Type.p>
                <Type.p>+331 710 006 50</Type.p>
                <a href="mailto:e-nota@glance-mediametrie.com">
                  <Type.p>
                    <em>e-nota@glance-mediametrie.com</em>
                  </Type.p>
                </a>
              </NanoFlex>
            </NanoFlex>
          </NanoFlex>
        </NanoFlex>
      </StyledAboutUs>
    );
  }
}
